<div class="footer flex-row flex-space-between-center">
    <div class="copyright">&copy; Contractor Nation</div>
    <div class="logo">
        <img src="assets/contractor-nation.png">
    </div>
</div>